export default function Dropdown({
  value,
  onChange,
  options,
  optionsWithGroups,
  id,
  disabled,
  placeholder,
}: {
  disabled?: boolean;
  id?: string;
  value: string;
  onChange: (value: string) => void;
  options?: { label: string; value: string; disabled?: boolean }[];
  optionsWithGroups?: Array<{
    label: string;
    options: { label: string; value: string; disabled?: boolean }[];
  }>;
  placeholder?: string;
}) {
  return (
    <div className="relative">
      <select
        id={id}
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        className="block w-full pl-3 pr-10 py-2 border border-gray-300 dark:border-zinc-700 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 dark:focus:ring-blue-400 dark:focus:border-blue-400 appearance-none bg-white dark:bg-zinc-900 dark:text-zinc-100"
      >
        <option value="" disabled>
          {placeholder ?? "Please select"}
        </option>
        {optionsWithGroups?.map((group) => (
          <optgroup key={group.label} label={group.label}>
            {group.options.map((option) => (
              <option
                key={option.value}
                value={option.value}
                disabled={option.disabled}
              >
                {option.label}
              </option>
            ))}
          </optgroup>
        ))}
        {options?.map((option) => (
          <option
            key={option.value}
            value={option.value}
            disabled={option.disabled}
          >
            {option.label}
          </option>
        ))}
      </select>
      <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none">
        <svg
          className="h-5 w-5 text-gray-400"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </div>
  );
}
